let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eWtnO")).then(() => parcelRequire('28sfx'));